import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { TheftProtectionGeofence } from '../contract/theft-protection-geofence.interface';

@Injectable({providedIn: 'root'})
export class GeofenceService {

  private readonly apiUrl = '/api/v1/geofences/all';
  private readonly notificationServiceApi = environment.APP_NOTIFICATION_SERVICE_BASE_URL;

  constructor(private http: HttpClient) {
  }

  loadAllGeofences(): Observable<Record<string, TheftProtectionGeofence[]>> {
    return this.http.get<Record<string, TheftProtectionGeofence[]>>(this.notificationServiceApi + this.apiUrl);
  }

}
